import * as React from "react"
const TcIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250" {...props}>
    <path d="M90 149.4H60.1v-31.8H90V91.9l-37.9 13.6c-2.9 1-4.6 4-4 6.9.1.3.1.6.2.9v36H23.1c-3.3 0-5.9 2.6-5.9 5.9v76.3c0 3.3 2.6 5.9 5.9 5.9s5.9-2.6 5.9-5.9v-70.4h61zm136.9 0h-25.2v-36c.1-.3.2-.6.2-.9.5-3-1.2-5.9-4-6.9L160 92v25.7h29.9v31.8H160v11.8h61v70.4c0 3.3 2.6 5.9 5.9 5.9s5.9-2.6 5.9-5.9v-76.3c0-3.4-2.6-6-5.9-6M149.3 67h37.6L125 12.5 63.1 67h37.6v114.1H63.1l61.9 54.5 61.9-54.5h-37.6z" />
  </svg>
)
export default TcIcon
